module.exports = __webpack_public_path__ + "img/OneBox_Mohpromt3.0b7de792.png";